/**
 * Created by Ivan on 09.03.2026
 */

Mission.TYPE_HUNGRY_GAMES = 94;

Mission.REGISTRATIONS.set(Mission.TYPE_HUNGRY_GAMES, () => ({
    available: cleverapps.config.availables.TYPE_HUNGRY_GAMES,
    logic: HungryGamesLogic,
    view: HungryGamesWindow,
    guideWindow: HungryGamesGuideWindow,
    schedule: ["FRI", "SAT", "SUN"],
    name: "HungryGames",
    teaser: true,
    semaphore: Mission.SEMAPHORE_ALWAYS,
    sideBarJson: bundles.sidebar.jsons.hungry_games_icon_json,
    rowView: cleverapps.config.type === "merge2" ? HungryGamesRowView : undefined,
    startWindow: HungryGamesStartWindow,
    bundle: "hungry_games",
    collectIcon: function () {
        const icon = new cleverapps.Spine(bundles.reward_icons.jsons.hungry_games_icon);
        icon.setAnimation(0, "animation", true);
        return icon;
    }
}));